import { logger } from '../logger/logger.class';
import { USER_AGENTS } from './browser-names.const';
export function detectBrowser() {
    const { userAgent } = window && window.navigator;
    const fallbackResult = { isUndetected: true };
    if (!userAgent) {
        logger.message('Unable to detect browser, empty navigator object');
        return fallbackResult;
    }
    const matchResult = USER_AGENTS.reduce((isMatched, [agent, regex]) => {
        const matchedAgent = regex.exec(userAgent);
        return isMatched ? isMatched : !!matchedAgent && { [agent]: !!matchedAgent };
    }, false);
    return matchResult || fallbackResult;
}
